var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDrpdwn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Button-DropDown") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Consultant-Admin-view",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Consultant-Admin-view---v1.2",
    transform: "translate(-606.000000, -816.000000)",
    fill: "#003d79"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Button-DropDown",
    transform: "translate(618.500000, 828.500000) scale(1, -1) translate(-618.500000, -828.500000) translate(606.500000, 816.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Chevron-Down",
    transform: "translate(11.995908, 12.333326) scale(1, -1) translate(-11.995908, -12.333326) translate(-0.004092, 5.162560)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9528722,14.3415319 L11.9528721,14.3415319 C11.3179698,14.3451626 10.70773,14.0959108 10.256952,13.6487922 L0.702472791,4.09431293 L0.702472781,4.09431292 C-0.234157597,3.15768254 -0.234157597,1.63909838 0.702472801,0.702472781 C1.63910318,-0.234157597 3.15768733,-0.234157597 4.09431294,0.702472801 L11.9528721,8.60880438 L19.8353175,1.01299338 L19.8353174,1.01299351 C20.717449,0.0321115632 22.2277112,-0.0479430299 23.2085979,0.834187882 C24.1894799,1.71631951 24.2695345,3.22658171 23.3874036,4.20746844 C23.3083252,4.29539951 23.2228258,4.37733633 23.1316111,4.45260294 L13.5771318,13.6726754 L13.5771318,13.6726754 C13.1403129,14.0938249 12.5595869,14.3329473 11.9528703,14.3415319 L11.9528722,14.3415319 Z",
    id: "Fill"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDrpdwn);
export default __webpack_public_path__ + "static/media/icon-drpdwn.91c8ce820be184bbb9e5345b3e46b2fe.svg";
export { ForwardRef as ReactComponent };